interface BadgeProps {
  children: React.ReactNode;
  variant?: "default" | "admin" | "user";
}

const Badge = ({ children, variant = "default" }: BadgeProps) => {
  const getVariantClasses = () => {
    switch (variant) {
      case "admin":
        return "bg-error-light text-error-text";
      case "user":
        return "bg-info-light text-info-text";
      default:
        return "bg-neutral-100 text-neutral-800";
    }
  };

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${getVariantClasses()}`}
    >
      {children}
    </span>
  );
};

export default Badge;
